<template>
  <div>
    <CrudGrid
      :footer-text="$t('messages.items_per_page')"
      :headers="headers"
      :items="anexos"
      :loading="loading"
      :options.sync="options"
      :sort-by.sync="sortBy"
    >
      <template v-slot:header>
        <div class="header-table">
          <CrudFilter :has-filters="hasFilters" @search="applyFilter" @clear="clearFilter">
            <v-list-item>
              <v-text-field
                color="#086318"
                :label="$t('inputs.file_types.search')"
                class="rounded-lg"
                hide-details
                outlined
                dense
                v-model="filterForm.name"
              />
            </v-list-item>
          </CrudFilter>
          <v-btn class="rounded-lg ml-2" elevation="1" color="#41916b" @click="openDialog()">
            <span class="textBtn">{{$t('buttons.new')}}</span>
          </v-btn>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <Menu :resource="item" @editItemGrid="editItem(item)">
          <ChangeStatus
            :resource="item"
            typeData="not-delete"
            @updateGrid="loadGridData()"
            url="attachments_type"
          />
        </Menu>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-chip :color="item.deleted_at ? '#fa5252' : '#bedfc5'" dark>
          {{ item.deleted_at ? "Inativo" : "Ativo" }}
        </v-chip>
      </template>
    </CrudGrid>

    <v-snackbar background-color="white" color="#41916b" v-model="snackbar">
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">{{ $t('buttons.close') }}</v-btn>
      </template>
    </v-snackbar>

    <Modal v-model="dialog">
      <FileTypes
        :resource="resource"
        @closeDialog="dialog = false"
        @updateGrid="loadGridData"
      />
    </Modal>
  </div>
</template>

<script>
import Menu from "../widgets/MenuActions-comp.vue";
import ChangeStatus from "../widgets/ChangeStatus-comp.vue";
import FileTypes from "./FileTypes.vue";
import CrudGrid from "../widgets/Grid.vue";
import CrudFilter from "../widgets/Filter.vue";
import Modal from "../widgets/Modal.vue";
import { mapActions } from "vuex";
import axios from "@/axios";

export default {
  components: {
    Menu,
    ChangeStatus,
    FileTypes,
    CrudGrid,
    CrudFilter,
    Modal,
  },

  data() {
    return {
      dialog: false,
      filterForm: {},
      snackbar: false,
      headers: [
        { text: "Lista de Anexos", align: "start", value: "name" },
        { text: "Status", align: "start", value: "status" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      page: 1,
      numberOfPages: 0,
      loading: false,
      options: {},
      sortBy: "name",
      resource: {},
      anexos: [],
      message: "",
      actions: [
        {
          name: "Editar",
          type: "modal",
          route: "",
          encryptionName: "",
          encryptionPassword: "",
          componentName: "FileTypes",
        },
      ],
    };
  },

  computed: {
    hasFilters() {
      return Object.values(this.filterForm).some(v => v != null && v !== '');
    },
  },

  created() {
    this.changeActionsData(this.actions);
    this.loadGridData();
  },

  methods: {
    ...mapActions(["changeActionsData", "changeSnackBarData"]),

    openDialog() {
      this.resource = {};
      this.dialog = true;
    },

    editItem(item) {
      this.resource = item;
      this.dialog = true;
    },

    loadGridData() {
      this.loading = true;
      axios
        .get("attachments_type/filter", { params: { name: this.filterForm.name || '' } })
        .then((response) => {
          this.anexos = response.data.data;
        })
        .catch(() => {
          this.message = "Erro ao carregar registros";
          this.snackbar = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    applyFilter() {
      this.loadGridData();
    },

    clearFilter() {
      this.filterForm = {};
      this.loadGridData();
    },
  },
};
</script>

<style scoped>
.header-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

@media (max-width: 768px) {
  .header-table {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
